import 'url-polyfill'

export const reloadWithLanguage = (languageCode) => {
  const url = new URL(location.href);
  url.searchParams.set('lang', languageCode);

  window.location.replace(url.toString());
};
